import React, { useCallback } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';
import TextTableCell from 'components/common/table/TextTableCell';

const EngineAttributeItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/engineAttributes/${data.engineAttributeId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.orderNo}</TableCell>
      <TextTableCell content={data.attributeName} />
      <TextTableCell content={data.description} />
      <TextTableCell content={data.expression} />
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton color='primary' size='small' variant='text' type='edit' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton
            color='primary'
            size='small'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            onClick={() => onDelete(data.engineAttributeId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

EngineAttributeItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default EngineAttributeItem;
